/* eslint-disable react/prop-types */
import React from 'react';
import {
  Form,
  Row,
  Col,
  DatePicker,
} from 'antd';
import PercentageInput from 'components/PercentageInput';
import Select from 'components/Select';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';

const TarifasISNTasas = ({
  form,
  rules,
  periodos,
  estados,
  selectedRowKeys,
  disableEditar,
  setVisibleInactivo,
}) => (
  <Form
    layout="vertical"
    form={form}
    scrollToFirstError
    name="general"
  >
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha_inicial"
          label="Fecha Inicial"
          rules={rules.fecha_inicial}
          hasFeedback
        >
          <DatePicker
            allowClear
            format="DD/MM/YYYY"
            disabled={selectedRowKeys.length}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="fecha_final"
          label="Fecha Final"
          rules={rules.required}
          hasFeedback
        >
          <DatePicker
            allowClear
            format="DD/MM/YYYY"
            disabled={selectedRowKeys.length}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <PercentageInput
          allowClear
          name="porcentaje"
          label="Porcentaje"
          rules={rules.porcentaje}
          hasFeedback
          disabled={selectedRowKeys.length}
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="ejercicio"
          label="Ejercicio"
          rules={rules.required}
          hasFeedback
        >
          <Select
            dataSource={periodos}
            disabled={selectedRowKeys.length}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="estados_globales"
          label="Estatus"
          rules={rules.estatus}
          hasFeedback
          initialValue={ESTATUS_ACTIVO}
        >
          <Select
            labelProp="descripcion"
            keyProp="id"
            dataSource={estados}
            activeInactive
            disabled={selectedRowKeys.length <= 0 || disableEditar}
            onChange={(val) => setVisibleInactivo(val === ESTATUS_INACTIVO)}
          />
        </Form.Item>
      </Col>
    </Row>
  </Form>
);

export default TarifasISNTasas;
